import { render, staticRenderFns } from "./SalesmanInformation.vue?vue&type=template&id=740ea0bd&scoped=true&"
import script from "./SalesmanInformation.vue?vue&type=script&lang=js&"
export * from "./SalesmanInformation.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanInformation.vue?vue&type=style&index=0&id=740ea0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740ea0bd",
  null
  
)

export default component.exports